import React from "react";
import { Helmet } from "react-helmet";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Container from "@material-ui/core/Container";
import { endOfTitle } from "../../../constants/constants";
import "../../program/pages/style.css";
import BroadcastForm from "../components/BroadcastForm";
import { Form } from "react-final-form";
import { validator } from "../validators";
import { IBroadcastEmailFrontEndModel } from "../types";
import { parseToBroadcastBackEndModel } from "../helpers/parseToBroadcastBackEndModel";
import useBroadcastQueries from "../hooks/useBroadcastQueries";
import { FormApi } from "final-form";
import { mutateErrors } from "../../../utils";
import { useNotify } from "../../notify/useNotify";
import { NotifyMode } from "../../notify/NotifyModeEnum";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    justifyContent: "center",
    columnGap: 24,
    flexDirection: "column",
  },
}));

export const BroadcastPage = () => {
  const classes = useStyles();
  const { broadcastEmail } = useBroadcastQueries();
  const snackNotify = useNotify();
  let formApi: FormApi<any>;

  const handleSubmit = async (values: IBroadcastEmailFrontEndModel) => {
    const result = validator(values);

    if (Object.entries(result).length > 0) {
      return result;
    }

    const parsedData = parseToBroadcastBackEndModel(values);
    try {
      await broadcastEmail(parsedData);
      snackNotify(
        "Success",
        "Email was broadcasted successfully",
        NotifyMode.SUCCESS,
      );

      setTimeout(() => {
        formApi?.reset();
      });
    } catch (error) {
      const { message } = mutateErrors(error);
      snackNotify("Error", message, NotifyMode.ERROR);
    }
  };

  return (
    <>
      <Helmet>
        <title>Broadcast{endOfTitle}</title>
      </Helmet>
      <Container maxWidth="lg" className={classes.root}>
        <Form
          onSubmit={handleSubmit}
          initialValues={{ subject: "", title: "", content: "" }}
          render={({ handleSubmit, form }) => {
            formApi = form;
            return <BroadcastForm handleSubmit={handleSubmit} />;
          }}
        />
      </Container>
    </>
  );
};
